import { Component, Input, OnChanges } from '@angular/core';

import { EditableList } from '®shared/reading-list/models';
import { License } from '®shared/tenant';

@Component({
  selector: 'rl-list-license',
  templateUrl: './list-license.component.html',
})
export class ListLicenseComponent implements OnChanges {
  @Input() editableList: EditableList;
  @Input() licenses: License[];

  displayLicense?: License;

  ngOnChanges() {
    if (
      this.editableList &&
      this.editableList.license &&
      this.editableList.license.license_url
    ) {
      // Only display the list license if it is not the 'no license' license
      if (this.editableList.license.isNoLicenseLicense) {
        this.displayLicense = null;
      } else {
        this.displayLicense = this.editableList.license;
      }
    } else if (this.licenses) {
      // If no license set on the list, fall back to the tenant default
      this.displayLicense = this.licenses.find(
        license => license.is_tenant_default,
      );
    }
  }
}
